import React, { useState } from 'react';
import { ADMIN_MFA_REQUIRED } from '../firebase';
import AbaConfiguracaoEmail from './AbaConfiguracaoEmail';
import { calcularPrecoFilial } from '../precoFilial';

const ABAS_CONFIGURACOES = [
  { id: 'pagamentos', titulo: 'Pagamentos' },
  { id: 'planos', titulo: 'Planos' },
  { id: 'modulos', titulo: 'Módulos' },
  { id: 'seguranca', titulo: 'Segurança' },
  { id: 'comunidade', titulo: 'Comunidade e limites' },
  { id: 'revisao', titulo: 'Contas de revisão' },
  { id: 'email', titulo: 'E-mail' },
];

function formatarDataMonitoramento(valor) {
  if (!valor) return 'Sem dados ainda';

  try {
    const data = typeof valor?.toDate === 'function' ? valor.toDate() : new Date(valor);
    if (Number.isNaN(data.getTime())) return 'Sem dados ainda';
    return data.toLocaleString('pt-BR');
  } catch (error) {
    return 'Sem dados ainda';
  }
}

function corStatusMonitoramento(status) {
  if (status === 'critico') return { fundo: '#fee2e2', borda: '#ef4444', texto: '#991b1b' };
  if (status === 'atencao') return { fundo: '#fef3c7', borda: '#f59e0b', texto: '#92400e' };
  return { fundo: '#edf6ff', borda: '#2f88d5', texto: '#0f4c81' };
}

function rotuloStatusMonitoramento(status) {
  if (status === 'critico') return 'Crítico';
  if (status === 'atencao') return 'Atenção';
  return 'Ok';
}

function normalizarEmailsRevisao(valor) {
  return [...new Set(
    String(valor || '')
      .split(/[\s,;]+/)
      .map((email) => email.trim().toLowerCase())
      .filter((email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)),
  )];
}

function AbaConfiguracoes({
  configGerais,
  handleConfigChange,
  monitorResumo,
  monitoramentoRetorno,
  monitoramentoCarregando,
  recarregarMonitoramento,
  somenteConsulta = false,
}) {
  const [abaAtiva, setAbaAtiva] = useState('pagamentos');
  const painel = (id) => ({
    id: `configuracoes-painel-${id}`,
    role: 'tabpanel',
    'aria-labelledby': `configuracoes-aba-${id}`,
    hidden: abaAtiva !== id,
    tabIndex: 0,
  });

  const navegarAbas = (event, indice) => {
    let destino;
    if (event.key === 'ArrowRight') destino = (indice + 1) % ABAS_CONFIGURACOES.length;
    if (event.key === 'ArrowLeft') destino = (indice - 1 + ABAS_CONFIGURACOES.length) % ABAS_CONFIGURACOES.length;
    if (event.key === 'Home') destino = 0;
    if (event.key === 'End') destino = ABAS_CONFIGURACOES.length - 1;
    if (destino === undefined) return;
    event.preventDefault();
    const id = ABAS_CONFIGURACOES[destino].id;
    setAbaAtiva(id);
    document.getElementById(`configuracoes-aba-${id}`)?.focus();
  };
  const contadoresMonitoramento = monitorResumo?.contadores || {};
  const alertasMonitoramento = Array.isArray(monitorResumo?.alertas_resumo) ? monitorResumo.alertas_resumo : [];
  const eventosRecentes = Array.isArray(monitorResumo?.eventos_recentes) ? monitorResumo.eventos_recentes : [];
  const estiloStatusMonitoramento = corStatusMonitoramento(monitorResumo?.status_geral || 'ok');
  const mfaObrigatorioEfetivo = ADMIN_MFA_REQUIRED || (configGerais.mfa_admin_obrigatorio || false);

  return (
    <div className="routine-panel">
      {somenteConsulta && (
        <div className="routine-callout routine-callout--warm" style={{ marginBottom: '16px' }}>
          <p className="routine-callout__text">
            Perfil técnico em modo somente consulta. Chaves sigilosas continuam ocultas e nenhuma configuração pode ser alterada.
          </p>
        </div>
      )}

      <div className="configuracoes-tabs" role="tablist" aria-label="Assuntos das configurações">
        {ABAS_CONFIGURACOES.map((aba, indice) => (
          <button key={aba.id} id={`configuracoes-aba-${aba.id}`} type="button" role="tab"
            aria-selected={abaAtiva === aba.id} aria-controls={`configuracoes-painel-${aba.id}`}
            tabIndex={abaAtiva === aba.id ? 0 : -1}
            className={`routine-btn ${abaAtiva === aba.id ? 'routine-btn--primary' : 'routine-btn--soft'}`}
            onClick={() => setAbaAtiva(aba.id)} onKeyDown={(event) => navegarAbas(event, indice)}>
            {aba.titulo}
          </button>
        ))}
      </div>

      <fieldset disabled={somenteConsulta} style={{ border: 0, padding: 0, margin: 0 }}>
      <div className="admin-section-stack">
        <div className="configuracoes-tabpanel" {...painel('email')}>
          <AbaConfiguracaoEmail somenteConsulta={somenteConsulta} />
        </div>

        <section className="routine-surface admin-surface-section configuracoes-tabpanel" {...painel('pagamentos')}>
          <div className="routine-title-group" style={{ marginBottom: '16px' }}>
            <p className="dashboard-section__eyebrow">Pagamentos</p>
            <h4 className="routine-section-title">Integração Asaas</h4>
            <p className="routine-section-subtitle">
              Informe o token da conta e defina a margem de carência usada antes do bloqueio total por inadimplência.
            </p>
          </div>

          <div className="admin-grid-2">
            <div className="routine-callout routine-callout--warm">
              <h5 className="routine-callout__title">Credenciais protegidas</h5>
              <p className="routine-callout__text" style={{ marginTop: '10px' }}>
                Access Token e token do webhook do Asaas agora ficam no Secret Manager do Firebase e não aparecem mais no painel.
              </p>
            </div>

            <div className="routine-field">
              <label className="routine-label">Dias de carência após o vencimento</label>
              <input
                type="number"
                min="0"
                value={configGerais.dias_carencia !== undefined ? configGerais.dias_carencia : 0}
                onChange={(e) => handleConfigChange('dias_carencia', Number(e.target.value))}
                className="routine-input"
              />
            </div>
          </div>

          <div className="routine-callout routine-callout--warm" style={{ marginTop: '18px' }}>
            <p className="routine-callout__text">
              Nunca compartilhe o Access Token. Ele funciona como chave mestra da sua operação financeira.
            </p>
          </div>
        </section>

        <section className="routine-surface admin-surface-section configuracoes-tabpanel" {...painel('modulos')}>
          <div className="routine-title-group" style={{ marginBottom: '16px' }}>
            <p className="dashboard-section__eyebrow">Monetização</p>
            <h4 className="routine-section-title">Módulos comerciais</h4>
          </div>

          <div className="admin-grid-2">
            <div className="routine-callout routine-callout--warm">
              <h5 className="routine-callout__title">Planos premium</h5>
              <label className="admin-checkbox-item" style={{ marginTop: '12px' }}>
                <input
                  type="checkbox"
                  checked={configGerais.exibir_premium || false}
                  onChange={(e) => handleConfigChange('exibir_premium', e.target.checked)}
                />
                <span>Exibir módulo de planos no app e no painel</span>
              </label>
              <p className="routine-callout__text" style={{ marginTop: '12px' }}>
                Se desligado, o acesso à assinatura e os bloqueios comerciais ficam invisíveis ao lojista.
              </p>
            </div>

            <div className="routine-callout">
              <h5 className="routine-callout__title">Ofertas da internet</h5>
              <label className="admin-checkbox-item" style={{ marginTop: '12px' }}>
                <input
                  type="checkbox"
                  checked={configGerais.aba_internet_ativa || false}
                  onChange={(e) => handleConfigChange('aba_internet_ativa', e.target.checked)}
                />
                <span>Habilitar módulo de ofertas online</span>
              </label>
              <p className="routine-callout__text" style={{ marginTop: '12px' }}>
                Ativa a aba de links e publicações virtuais para o lado consumidor do ecossistema.
              </p>
            </div>
          </div>
        </section>

        <section className="routine-surface admin-surface-section configuracoes-tabpanel" {...painel('seguranca')}>
          <div className="routine-title-group" style={{ marginBottom: '16px' }}>
            <p className="dashboard-section__eyebrow">Segurança operacional</p>
            <h4 className="routine-section-title">MFA e monitoramento</h4>
          </div>

          <div className="admin-grid-2">
            <div className="routine-callout routine-callout--diamond">
              <h5 className="routine-callout__title">MFA obrigatório</h5>
              <p className="routine-callout__text" style={{ marginTop: '10px' }}>
                Administradores e técnicos confirmam o acesso com SMS antes de usar áreas protegidas do painel.
              </p>
            </div>

            <div className="routine-callout">
              <h5 className="routine-callout__title">Ações protegidas</h5>
              <p className="routine-callout__text" style={{ marginTop: '10px' }}>
                Cobranças, filiais, permissões e outras ações críticas são validadas no servidor com identidade, perfil, vínculo e limite de tentativas.
              </p>
            </div>
          </div>

          <div className="admin-grid-2" style={{ marginTop: '14px' }}>
            <label className="admin-checkbox-item">
              <input
                type="checkbox"
                checked={mfaObrigatorioEfetivo}
                onChange={(e) => handleConfigChange('mfa_admin_obrigatorio', e.target.checked)}
                disabled={somenteConsulta || ADMIN_MFA_REQUIRED}
              />
              <span>Exigir MFA por SMS para administradores</span>
            </label>

            <div className="routine-callout">
              <p className="routine-callout__text">
                A MFA permanece obrigatória. O monitoramento abaixo registra erros operacionais e bloqueios por excesso de tentativas.
              </p>
            </div>
          </div>

          <div className="routine-callout routine-callout--diamond" style={{ marginTop: '18px' }}>
            <div className="routine-toolbar">
              <div className="routine-title-group">
                <h5 className="routine-callout__title" style={{ marginBottom: '6px' }}>Painel de monitoramento operacional</h5>
                <p className="routine-callout__text">
                  O resumo abaixo usa consolidação barata, sem listener em tempo real, para acompanhar erros e bloqueios.
                </p>
              </div>

              <div className="routine-actions">
                <button
                  onClick={recarregarMonitoramento}
                  disabled={monitoramentoCarregando}
                  className="routine-btn routine-btn--diamond"
                >
                  {monitoramentoCarregando ? 'Atualizando...' : 'Atualizar agora'}
                </button>
              </div>
            </div>

            {!!monitoramentoRetorno?.mensagem && (
              <div
                className="routine-callout"
                style={{
                  marginTop: '14px',
                  backgroundColor: monitoramentoRetorno.tipo === 'error' ? '#fef2f2' : '#ecfdf5',
                  borderColor: monitoramentoRetorno.tipo === 'error' ? '#fca5a5' : '#86efac',
                }}
              >
                <p
                  className="routine-callout__text"
                  style={{
                    color: monitoramentoRetorno.tipo === 'error' ? '#991b1b' : '#166534',
                  }}
                >
                  {monitoramentoRetorno.mensagem}
                </p>
              </div>
            )}

            {!monitorResumo && (
              <p className="routine-callout__text" style={{ marginTop: '14px' }}>
                Ainda não existe resumo salvo. O painel será preenchido automaticamente após a rotina agendada ou pelo botão acima.
              </p>
            )}

            {monitorResumo && (
              <>
                <div className="admin-metrics-grid" style={{ marginTop: '16px' }}>
                  <div className="admin-metric-card" style={{ backgroundColor: estiloStatusMonitoramento.fundo, borderColor: estiloStatusMonitoramento.borda, color: estiloStatusMonitoramento.texto }}>
                    <div className="admin-metric-card__label">Status geral</div>
                    <div className="admin-metric-card__value">{rotuloStatusMonitoramento(monitorResumo.status_geral)}</div>
                  </div>

                  <div className="admin-metric-card">
                    <div className="admin-metric-card__label">Atualizado em</div>
                    <div className="admin-metric-card__value admin-metric-card__value--small">
                      {formatarDataMonitoramento(monitorResumo.atualizado_em || monitorResumo.atualizado_em_iso)}
                    </div>
                  </div>

                  <div className="admin-metric-card">
                    <div className="admin-metric-card__label">MFA administrativo</div>
                    <div className="admin-metric-card__value admin-metric-card__value--small">
                      {monitorResumo.configuracao_seguranca?.mfa_admin_obrigatorio ? 'Obrigatório' : 'Ativo'}
                    </div>
                  </div>

                  <div className="admin-metric-card">
                    <div className="admin-metric-card__label">Erros 24h</div>
                    <div className="admin-metric-card__value">{contadoresMonitoramento.error || 0}</div>
                  </div>

                  <div className="admin-metric-card">
                    <div className="admin-metric-card__label">Avisos 24h</div>
                    <div className="admin-metric-card__value">{contadoresMonitoramento.warning || 0}</div>
                  </div>

                  <div className="admin-metric-card">
                    <div className="admin-metric-card__label">Rate limit 24h</div>
                    <div className="admin-metric-card__value">{contadoresMonitoramento.rate_limit_bloqueado || 0}</div>
                  </div>
                </div>

                <div className="routine-callout" style={{ marginTop: '16px' }}>
                  <h5 className="routine-callout__title">Resumo automático</h5>
                  {alertasMonitoramento.map((alerta, index) => (
                    <div key={`${alerta}-${index}`} className="admin-monitor-line">
                      {alerta}
                    </div>
                  ))}
                  <p className="routine-callout__text" style={{ marginTop: '10px' }}>
                    Janela: últimas {monitorResumo.janela_horas || 24} horas. Base: {monitorResumo.eventos_considerados || 0} evento(s)
                    {monitorResumo.amostra_limitada ? `, limitada aos últimos ${monitorResumo.limite_amostra_eventos || 40}.` : '.'}
                  </p>
                </div>

                <div className="routine-callout" style={{ marginTop: '16px' }}>
                  <h5 className="routine-callout__title">Últimos eventos relevantes</h5>
                  {!eventosRecentes.length && (
                    <p className="routine-callout__text">Nenhum evento recente registrado.</p>
                  )}

                  {!!eventosRecentes.length && (
                    <div className="admin-monitor-events">
                      {eventosRecentes.map((evento) => (
                        <div key={evento.id} className="admin-monitor-event">
                          <div className="admin-monitor-event__head">
                            <strong>{evento.tipo}</strong>
                            <span>{formatarDataMonitoramento(evento.criado_em_iso)}</span>
                          </div>
                          <div className="admin-monitor-event__meta">
                            Severidade: <b>{evento.severidade}</b>
                            {evento.contexto ? ` | Contexto: ${evento.contexto}` : ''}
                            {evento.status ? ` | Status: ${evento.status}` : ''}
                          </div>
                          {evento.mensagem && <div className="admin-monitor-event__message">{evento.mensagem}</div>}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </>
            )}
          </div>

          <div className="routine-callout" style={{ marginTop: '18px' }}>
            <h5 className="routine-callout__title">Reautenticação do lojista</h5>
            <div className="admin-grid-2" style={{ marginTop: '12px' }}>
              <label className="admin-checkbox-item">
                <input
                  type="checkbox"
                  checked={configGerais.reautenticacao_lojista_mudar_plano || false}
                  onChange={(e) => handleConfigChange('reautenticacao_lojista_mudar_plano', e.target.checked)}
                />
                <span>Exigir reautenticação antes de mudar plano</span>
              </label>

              <label className="admin-checkbox-item">
                <input
                  type="checkbox"
                  checked={configGerais.reautenticacao_lojista_cancelar_assinatura || false}
                  onChange={(e) => handleConfigChange('reautenticacao_lojista_cancelar_assinatura', e.target.checked)}
                />
                <span>Exigir reautenticação antes de cancelar assinatura</span>
              </label>
            </div>
          </div>
        </section>

        <section className="routine-surface admin-surface-section configuracoes-tabpanel" {...painel('revisao')}>
          <div className="routine-title-group" style={{ marginBottom: '16px' }}>
            <p className="dashboard-section__eyebrow">Lojas de aplicativos</p>
            <h4 className="routine-section-title">Contas de revisão</h4>
            <p className="routine-section-subtitle">
              Cadastre as contas usadas por lojas de aplicativos, como Google Play e App Store. Elas ficam na cidade interna Revisão - Teste e não podem alterar a localização nem adicionar outras cidades.
            </p>
          </div>

          <div className="routine-field">
            <label className="routine-label" htmlFor="emails-revisao-google">
              E-mails de revisão
            </label>
            <textarea
              id="emails-revisao-google"
              className="routine-input"
              rows="5"
              defaultValue={(Array.isArray(configGerais.emails_contas_revisao) ? configGerais.emails_contas_revisao : (Array.isArray(configGerais.emails_revisao_google) ? configGerais.emails_revisao_google : [])).join('\n')}
              onBlur={(event) => handleConfigChange('emails_contas_revisao', normalizarEmailsRevisao(event.target.value))}
              placeholder={'revisor-lojista@exemplo.com\nrevisor-usuario@exemplo.com'}
            />
            <p className="routine-callout__text" style={{ marginTop: '10px' }}>
              Informe um e-mail por linha. A lista aceita quantas contas forem necessárias e só entra em vigor após sair e entrar novamente no app.
            </p>
          </div>
        </section>

        <section className="routine-surface admin-surface-section configuracoes-tabpanel" {...painel('comunidade')}>
          <div className="routine-title-group" style={{ marginBottom: '16px' }}>
            <p className="dashboard-section__eyebrow">Comunidade e limites</p>
            <h4 className="routine-section-title">Regras do ecossistema</h4>
          </div>

          <div className="admin-checkbox-grid" style={{ marginBottom: '18px' }}>
            <label className="admin-checkbox-item">
              <input
                type="checkbox"
                checked={configGerais.lojistas_comentam || false}
                onChange={(e) => handleConfigChange('lojistas_comentam', e.target.checked)}
              />
              <span>Lojistas podem comentar em qualquer postagem</span>
            </label>

            <label className="admin-checkbox-item">
              <input
                type="checkbox"
                checked={configGerais.lojistas_veem_lojistas || false}
                onChange={(e) => handleConfigChange('lojistas_veem_lojistas', e.target.checked)}
              />
              <span>Lojistas podem ver postagens de outros lojistas no feed</span>
            </label>
          </div>

          <div className="admin-grid-2">
            <div className="routine-callout">
              <h5 className="routine-callout__title">Limites de postagem</h5>
              <div className="admin-grid-2" style={{ marginTop: '12px' }}>
                <div className="routine-field">
                  <label className="routine-label">Gratuito (mensal geral)</label>
                  <input
                    type="number"
                    value={configGerais.limite_mensal_gratuito !== undefined ? configGerais.limite_mensal_gratuito : 300}
                    onChange={(e) => handleConfigChange('limite_mensal_gratuito', Number(e.target.value))}
                    className="routine-input"
                  />
                </div>

                <div className="routine-field">
                  <label className="routine-label">Gratuito (lote por semana)</label>
                  <input
                    type="number"
                    value={configGerais.limite_gratuito !== undefined ? configGerais.limite_gratuito : 10}
                    onChange={(e) => handleConfigChange('limite_gratuito', Number(e.target.value))}
                    className="routine-input"
                  />
                </div>

                <div className="routine-field">
                  <label className="routine-label">Bronze (lote por semana)</label>
                  <input
                    type="number"
                    value={configGerais.limite_bronze !== undefined ? configGerais.limite_bronze : 20}
                    onChange={(e) => handleConfigChange('limite_bronze', Number(e.target.value))}
                    className="routine-input"
                  />
                </div>
              </div>
            </div>

            <div className="routine-callout routine-callout--warm">
              <h5 className="routine-callout__title">Auto-limpeza</h5>
              <div className="routine-field" style={{ marginTop: '12px' }}>
                <label className="routine-label">Excluir ofertas normais após quantos dias</label>
                <input
                  type="number"
                  value={configGerais.dias_limpeza_postagens || 30}
                  onChange={(e) => handleConfigChange('dias_limpeza_postagens', Number(e.target.value))}
                  className="routine-input"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="routine-surface admin-surface-section configuracoes-tabpanel" {...painel('planos')}>
          <div className="routine-title-group" style={{ marginBottom: '16px' }}>
            <p className="dashboard-section__eyebrow">Precificação</p>
            <h4 className="routine-section-title">Valores das assinaturas</h4>
            <p className="routine-section-subtitle">
              Ajuste o valor mensal de cada plano e da filial adicional usada na operação comercial.
            </p>
          </div>

          <div className="admin-metrics-grid">
            <div className="routine-field">
              <label className="routine-label">Plano Bronze</label>
              <input
                type="number"
                step="0.01"
                value={configGerais.preco_bronze || 49.9}
                onChange={(e) => handleConfigChange('preco_bronze', Number(e.target.value))}
                className="routine-input"
              />
            </div>

            <div className="routine-field">
              <label className="routine-label">Plano Prata</label>
              <input
                type="number"
                step="0.01"
                value={configGerais.preco_prata || 89.9}
                onChange={(e) => handleConfigChange('preco_prata', Number(e.target.value))}
                className="routine-input"
              />
            </div>

            <div className="routine-field">
              <label className="routine-label">Plano Ouro</label>
              <input
                type="number"
                step="0.01"
                value={configGerais.preco_ouro || 149.9}
                onChange={(e) => handleConfigChange('preco_ouro', Number(e.target.value))}
                className="routine-input"
              />
            </div>

            <div className="routine-field">
              <label className="routine-label">Plano Diamante</label>
              <input
                type="number"
                step="0.01"
                value={configGerais.preco_diamante || 997}
                onChange={(e) => handleConfigChange('preco_diamante', Number(e.target.value))}
                className="routine-input"
              />
            </div>

            <div className="routine-field">
              <label className="routine-label" htmlFor="preco-filial-ouro">Filial Ouro</label>
              <input
                id="preco-filial-ouro"
                type="number"
                step="0.01"
                value={configGerais.preco_filial || 29.9}
                onChange={(e) => handleConfigChange('preco_filial', Number(e.target.value))}
                className="routine-input"
              />
            </div>
            <div className="routine-field">
              <label className="routine-label" htmlFor="preco-filial-diamante">Filial Diamante</label>
              <input
                id="preco-filial-diamante"
                type="number"
                min="0.01"
                step="0.01"
                value={calcularPrecoFilial(configGerais, 'diamante')}
                onChange={(e) => handleConfigChange('preco_filial_diamante', Number(e.target.value))}
                className="routine-input"
              />
            </div>
          </div>
          <p className="routine-section-subtitle">
            Filial Diamante usa o valor da filial Ouro enquanto um valor próprio não for definido. O financeiro permanece centralizado na matriz.
          </p>

          <label className="admin-checkbox-item" style={{ marginTop: '18px' }}>
            <input
              type="checkbox"
              checked={configGerais.nao_gerar_cobranca_pequena_filial !== false}
              onChange={(e) => handleConfigChange('nao_gerar_cobranca_pequena_filial', e.target.checked)}
            />
            <span>Não gerar cobrança pequena; ativar filial agora e cobrar na próxima renovação</span>
          </label>
          <p className="routine-section-subtitle" style={{ marginTop: '8px' }}>
            Quando o pró-rata da filial ficar abaixo de R$ 5,00, mínimo aceito pelo Asaas, a filial é ativada sem fatura avulsa.
          </p>
        </section>
      </div>
      </fieldset>
    </div>
  );
}

export default AbaConfiguracoes;
